module.exports = __webpack_public_path__ + "static/Mobile-cover-3042f4beb70f4c45b81a9cf69f19c19c.png";